import { RequestResetPasswordForm } from "./request.types";

export const initialResetPasswordForm: RequestResetPasswordForm = {
  email: "",
};
export const sendRequestBtnId = "send-request-btn";

export const btnTooltipTimeout = 3000;
